async function getAppVersion() {
  return `7.99.82`;
}

export { getAppVersion };
